import { Observable } from "rxjs";
import { ADCData } from "../../types";
import { getARCDataObservable } from "./ADCModel";

export const getADCSolutionData = (): Observable<ADCData> => getARCDataObservable();